import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  HomeIcon,
  BookOpenIcon,
  UsersIcon,
  Cog6ToothIcon,
  BriefcaseIcon,
  AcademicCapIcon,
  BuildingOfficeIcon,
  InformationCircleIcon,
  BellAlertIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
} from "@heroicons/react/24/outline";

const Sidebar = () => {
  const location = useLocation();
  const [minimized, setMinimized] = useState(false);

  const navItems = [
    { name: "Dashboard", href: "/dashboard", icon: HomeIcon },
    { name: "Notification", href: "/home", icon: BellAlertIcon },
    { name: "Courses", href: "/courses", icon: BookOpenIcon },
    { name: "Users", href: "/users", icon: UsersIcon },
    { name: "Internships", href: "/internships", icon: BriefcaseIcon },
    { name: "Exams", href: "/exams", icon: AcademicCapIcon },
    { name: "Placement", href: "/placement", icon: BuildingOfficeIcon },
    { name: "About", href: "/about", icon: InformationCircleIcon },
    { name: "System", href: "/system", icon: Cog6ToothIcon },
  ];

  return (
    <div
      className={`flex flex-col ${
        minimized ? "w-16" : "w-64"
      } bg-gray-800 text-white transition-all duration-200`}
    >
      <div className="flex items-center justify-between h-16 bg-gray-900 px-2">
        <span
          className={`text-xl font-bold transition-all duration-200 ${
            minimized ? "hidden" : "block"
          }`}
        >
          Admin Panel
        </span>
        <button
          onClick={() => setMinimized((m) => !m)}
          className="p-1 rounded hover:bg-gray-700 focus:outline-none"
          title={minimized ? "Maximize" : "Minimize"}
        >
          {minimized ? (
            <ChevronRightIcon className="h-6 w-6" />
          ) : (
            <ChevronLeftIcon className="h-6 w-6" />
          )}
        </button>
      </div>
      <nav className="flex-1 px-2 py-4 space-y-2">
        {navItems.map((item) => (
          <Link
            key={item.name}
            to={item.href}
            className={`flex items-center px-2 py-2 text-sm font-medium rounded-md transition-all duration-200 ${
              location.pathname === item.href
                ? "bg-gray-700 text-white"
                : "text-gray-300 hover:bg-gray-700 hover:text-white"
            } ${minimized ? "justify-center" : ""}`}
          >
            <item.icon className="h-5 w-5" />
            <span
              className={`ml-3 transition-all duration-200 ${
                minimized ? "hidden" : "inline"
              }`}
            >
              {item.name}
            </span>
          </Link>
        ))}
      </nav>
    </div>
  );
};

export default Sidebar;
